import { useState } from "react";
import { CalendarPlus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ModalOverlay } from "@/components/ui/modal-overlay";
import { ProductionOrderForm } from "./ProductionOrderForm";
import type { ProductionOrder } from "../../types/production-orders.types.js";

// Modal de criação/edição de OP (padrão de overlay do repo, ver EditPlannedTimesDialog).
// `onCancelOrder` (só edição) cancela a OP a partir do próprio modal — único surface de detalhe da OP.
export function ProductionOrderFormDialog({
  mode,
  order,
  canCancel,
  onCancelOrder,
  onClose,
  lockedLineId,
}: {
  mode: "create" | "edit";
  order?: ProductionOrder;
  canCancel?: boolean;
  onCancelOrder?: () => void;
  onClose: () => void;
  /** Origem detalhe da linha: pré-seleciona e trava a linha (criação). */
  lockedLineId?: string;
}) {
  const [dirty, setDirty] = useState(false);
  return (
    <ModalOverlay
      onClose={onClose}
      title={mode === "edit" ? "Editar Ordem de Produção" : "Nova Ordem de Produção"}
      confirmDismiss={dirty}
    >
      <div className="flex items-start gap-3 border-b p-5">
        <span className="border-brand-500/30 flex h-9 w-9 shrink-0 items-center justify-center rounded-md border bg-brand-50 text-brand-600">
          <CalendarPlus className="h-[18px] w-[18px]" />
        </span>
        <div className="flex-1">
          <h2 id="op-form-title" className="text-[17px] font-semibold leading-snug">
            {mode === "edit" ? "Editar Ordem de Produção" : "Nova Ordem de Produção"}
          </h2>
          <p className="text-xs text-text-secondary">
            Programe uma produção · inicia automaticamente no horário
          </p>
        </div>
        <Button variant="ghost" size="icon" aria-label="Fechar" onClick={onClose}>
          <X className="h-4 w-4" />
        </Button>
      </div>
      <div className="overflow-y-auto p-5">
        <ProductionOrderForm
          mode={mode}
          order={order}
          onDone={onClose}
          onCancel={onClose}
          onCancelOrder={canCancel ? onCancelOrder : undefined}
          onDirtyChange={setDirty}
          lockedLineId={lockedLineId}
        />
      </div>
    </ModalOverlay>
  );
}
